import { useStore } from "../../stores/StoreContext";
import { ThreadService } from "../LogicServices/ThreadService";

export function useThreadService(): ThreadService {
  const storeContext = useStore();
  return new ThreadService(storeContext);
}
